import React, { useState } from 'react';
import { PlusCircle, Mail, Pencil, Trash2, MoreVertical, Copy } from 'lucide-react';
import { Modal, Dropdown, Tooltip, Button } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { useAppData } from './context/DataContext';
import CreateList from './CreateList';
import Navbar from './Navbar';
import Footer from './Footer';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { ArrowLeftOutlined } from '@ant-design/icons';


const Lists = () => {
    const { selectedOrganizationInfo, loggedInUser } = useAppData();

    const [lists, setLists] = useState(selectedOrganizationInfo?.lists || []);
    const [showCreateView, setShowCreateView] = useState(false);
    const [editingList, setEditingList] = useState(null);
    const [showDeleteConfirm, setShowDeleteConfirm] = useState(null);

    const navigate = useNavigate();



    const handleCreateList = () => {
        setShowCreateView(true);
    };

    const handleEditList = (list) => {
        setEditingList(list);
        setShowCreateView(true);
    };

    const handleDeleteList = async (listId) => {
        try {
            const updatedLists = lists.filter(list => list._id !== listId);

            // Update database
            await axios.put(`${process.env.REACT_APP_SERVER_URL}organizations`, {
                lists: updatedLists
            }, {
                params: {
                    name: selectedOrganizationInfo.name
                },
                headers: {
                    'x-api-key': process.env.REACT_APP_UMMAHFY_API_KEY
                }
            });

            // Update local state after successful API call
            setLists(updatedLists);
            setShowDeleteConfirm(null);
        } catch (error) {
            console.error('Error deleting list:', error);
            // Could add error notification here
        }
    };

    const handleDuplicateList = (list) => {
        const newList = {
            _id: Date.now().toString(),
            name: `Copy of ${list.name}`,
            emails: [...list.emails]
        };

        setLists(prevLists => [...prevLists, newList]);

        // Update in database
        const updatedLists = [...lists, newList];
        axios.put(`${process.env.REACT_APP_SERVER_URL}organizations`, {
            lists: updatedLists
        }, {
            params: {
                name: selectedOrganizationInfo.name
            },
            headers: {
                'x-api-key': process.env.REACT_APP_UMMAHFY_API_KEY
            }
        }).catch(error => {
            console.error('Error duplicating list:', error);
        });
    };

    const handleSendMessage = (list) => {
        console.log('Sending message to list:', list.name);
    };

    const handleBack = () => {
        setShowCreateView(false);
        setEditingList(null);
    };

    const handleSave = async (listName, emails) => {
        try {
            const updatedLists = [...lists];
            const existingListIndex = updatedLists.findIndex(list =>
                editingList ? list._id === editingList._id : false
            );

            if (existingListIndex !== -1) {
                // Update existing list
                updatedLists[existingListIndex] = {
                    ...updatedLists[existingListIndex],
                    name: listName,
                    emails: emails
                };
            } else {
                // Add new list with timestamp as ID
                updatedLists.push({
                    _id: Date.now().toString(),
                    name: listName,
                    emails: emails
                });
            }

            // Make API call to update organization's lists
            await axios.put(`${process.env.REACT_APP_SERVER_URL}organizations`, {
                lists: updatedLists
            }, {
                params: {
                    name: selectedOrganizationInfo.name
                },
                headers: {
                    'x-api-key': process.env.REACT_APP_UMMAHFY_API_KEY
                }
            });

            setLists(updatedLists);
            handleBack();
        } catch (error) {
            console.error('Error saving list:', error);
        }
    };

    const getMenuItems = (list) => {
        return {
            items: [
                {
                    key: '2',
                    icon: <Copy size={16} />,
                    label: 'Duplicate',
                    onClick: (e) => {
                        e.domEvent.stopPropagation();
                        handleDuplicateList(list);
                    }
                },
                {
                    key: '3',
                    icon: <Trash2 size={16} className="text-red-500" />,
                    label: <span className="text-red-500">Delete</span>,
                    onClick: (e) => {
                        e.domEvent.stopPropagation();
                        setShowDeleteConfirm(list._id);
                    }
                }
            ]
        };
    };

    if (showCreateView) {
        return (
            <div className="lists-container">
                <div className="create-view-header">
                    {/* <h1 className="lists-title">
                        {editingList ? 'Edit List' : 'Create New List'}
                    </h1> */}
                </div>
                <CreateList
                    initialEmails={editingList?.emails}
                    initialName={editingList?.name}
                    onSave={(name, emails) => handleSave(name, emails)}
                    onCancel={() => {
                        setShowCreateView(false);
                        setEditingList(null);
                    }}
                />
            </div>
        );
    }

    return (
        <>
            <div className="wrapper">
                <Navbar />
                <div class="list-page-wrapper">
                    <Button
                        onClick={() => navigate('/organizerSettings')}
                        className="back-btn"
                        icon={<ArrowLeftOutlined />}
                    >
                        Back
                    </Button>

                    <div class="list-page-div">
                        {/* <Button
                        type="text"
                        onClick={() => navigate('/organizerSettings')}
                        style={{
                            marginBottom: '16px',
                           
                            color: '#666',
                            width:"fit-content"
                        }}
                    >
                        ← Back to Settings
                    </Button> */}

                        <div className="lists-header">
                            <h1 className="lists-title">Message Lists</h1>
                            <Button
                                type="primary"
                                icon={<PlusOutlined />}
                                onClick={handleCreateList}
                                className="create-list-button"
                            >
                                Create List
                            </Button>
                        </div>

                        <div className="lists-grid">
                            {lists.map(list => (
                                <div
                                    key={list._id}
                                    className="list-card"
                                    onClick={() => handleEditList(list)}
                                    style={{ cursor: 'pointer' }} // Add pointer cursor
                                >
                                    <div className="list-header">
                                        <div className="list-info">
                                            <h3 className="list-name">{list.name}</h3>
                                            <p className="list-stats">
                                                {list.emails.length} contacts
                                            </p>
                                        </div>
                                        <div className="list-actions" onClick={(e) => e.stopPropagation()}>
                                            {/* <Tooltip title="To message this list, click the attendees box on an event and click 'Message Blast'">
                                            <button
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    handleSendMessage(list);
                                                }}
                                                className="action-button message"
                                                title="Send Message"
                                            >
                                                <Mail size={20} />
                                            </button>
                                        </Tooltip> */}
                                            <Dropdown
                                                menu={getMenuItems(list)}
                                                trigger={['click']}
                                                placement="bottomRight"
                                            >
                                                <button
                                                    className="action-button"
                                                    onClick={(e) => e.stopPropagation()}
                                                >
                                                    <MoreVertical size={20} />
                                                </button>
                                            </Dropdown>
                                        </div>
                                    </div>
                                </div>
                            ))}

                            {lists.length === 0 && (
                                <div className="empty-state">
                                    <p>You haven't created any lists yet.</p>
                                    <button
                                        onClick={handleCreateList}
                                        className="empty-state-button"
                                    >
                                        Create List
                                    </button>
                                </div>
                            )}
                        </div>

                        <Modal
                            title="Delete List"
                            open={showDeleteConfirm !== null}
                            onCancel={() => setShowDeleteConfirm(null)}
                            onOk={() => handleDeleteList(showDeleteConfirm)}
                            okText="Delete"
                            okButtonProps={{
                                danger: true,
                                className: 'bg-red-600'
                            }}
                        >
                            <p>Are you sure you want to delete this list? This action cannot be undone.</p>
                        </Modal>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
};

export default Lists;